import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { withRouter } from "../../services/security/withRouter";

const voices = [
    { name: 'Alloy', url: 'https://cdn.openai.com/API/docs/audio/alloy.wav' },
    { name: 'Ash', url: 'https://cdn.openai.com/API/docs/audio/ash.wav' },
    { name: 'Coral', url: 'https://cdn.openai.com/API/docs/audio/coral.wav' },
    { name: 'Echo', url: 'https://cdn.openai.com/API/docs/audio/echo.wav' },
    { name: 'Fable', url: 'https://cdn.openai.com/API/docs/audio/fable.wav' },
    { name: 'Onyx', url: 'https://cdn.openai.com/API/docs/audio/onyx.wav' },
    { name: 'Nova', url: 'https://cdn.openai.com/API/docs/audio/nova.wav' },
    { name: 'Sage', url: 'https://cdn.openai.com/API/docs/audio/sage.wav' },
    { name: 'Shimmer', url: 'https://cdn.openai.com/API/docs/audio/shimmer.wav' },
];

const VoiceTrials = (props) => {
    const handleBackClick = () => {
        const queryParams = new URLSearchParams(props.location.search);
        const speechId = queryParams.get('id');
        if (speechId) {
            props.navigate(`/speech?id=${speechId}`);
        } else {
            props.navigate('/speech');
        }
    };

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={handleBackClick}
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                >
                    Back
                </Button>
                <Typography variant="h4" gutterBottom>
                    Voice Trials
                </Typography>
            </Box>
            <Grid container spacing={2}>
                {voices.map((voice) => (
                    <Grid item xs={12} sm={6} md={4} key={voice.name}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6">{voice.name}</Typography>
                                <CardMedia component="audio" controls src={voice.url} />
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default withRouter(VoiceTrials);